// extracted by mini-css-extract-plugin
export var active = "_a5-a";
export var activeIndicator = "_a5-8";
export var animate = "_a5-9";
export var disabled = "_a5-b";
export var fullWidth = "_a5-2";
export var lg = "_a5-7";
export var md = "_a5-6";
export var redoButtonTabGroup = "_a5-0";
export var sm = "_a5-5";
export var tabButton = "_a5-3";
export var tabButtonsContainer = "_a5-1";
export var xs = "_a5-4";